import styled from "styled-components";
import { theme } from "theme";

export const Divider = styled.div`
  width: 100%;
  height: 1.5px;
  background-color: ${(props) => props.theme.neoFontColor};
  margin: 4rem 0rem;
`;

export const TableWrapper = styled.div`
  max-width: 100%;
  max-height: 100vh;
  border-radius: 10px;
  overflow-x: scroll;
  float: left;
  ::-webkit-scrollbar {
    display: none;
  }
`;

export const FlexProductList = styled.table`
  margin-bottom: 1.4rem;
  border: ${(props) => `1px solid ${props.theme.primaryColor}`};
  overflow: hidden;
  border-radius: 10px;
  height: 3rem;
  border-collapse: separate;
  border-spacing: 0;
  background: #f9fafd;
  float: left;
  ::-webkit-scrollbar {
    display: none;
  }
`;
export const IndividualList = styled.th`
  cursor: pointer;
  max-width: 50px;
  border-left: ${(props) => `0.3px solid ${props.theme.primaryColor}`};
  border-right: ${(props) => `0.5px solid ${props.theme.primaryColor}`};
  padding: 1.4rem 1rem;
  background: ${(props) => (props.bgColor ? props.bgColor : "transparent")};
`;

export const StickyCell = styled.th`
  position: sticky;
  left: 0;
  z-index: 8;
  background: ${(props) => props.bgColor};
`;

export const TopHeader = styled.div`
  min-width: 175px;
  display: flex;
  padding: 22px 22px;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const Table = styled.table`
  display: block;
  max-width: -moz-fit-content;
  max-width: fit-content;
  border-collapse: collapse;
  border: none;
  thead {
    position: sticky;
    top: 0;
    z-index: 10;
    & > tr:first-child th:first-child {
      background: ${(props) => props.theme.cardBackgroundColor};
      position: sticky;
      top: 0;
      left: 0;
      z-index: 13;
    }
    & > tr:first-child :not(:first-child) {
      background: ${(props) => props.theme.cardBackgroundColor};
    }

    td {
      background: white;
      position: sticky;
      top: 0;
      left: 0;
      z-index: 12;
    }
  }
  tbody tr {
    border-bottom: 0.5px solid #3f9dff;
  }
`;

export const InsuranceCardsWrapper = styled.section`
  display: flex;
  gap: 2rem;
  overflow: scroll;
  margin-top: 2rem;
  user-select: none;
  &::-webkit-scrollbar {
    display: none;
  }

  &::-webkit-scrollbar-thumb {
    display: none;
  }

  &::-webkit-scrollbar-track {
    display: none;
  }
`;

export const SplitWrapper = styled.section`
  display: flex;
  flex-direction: row;
  gap: 2rem;
`;

export const DownloadLink = styled.p`
  font-family: "Montserrat";
  font-size: 14px;
  color: #2287ff;
  text-align: left;
  text-decoration: underline;
  cursor: pointer;
`;

export const ECardPreviewMain = styled.section`
`;

export const ECardDownloadWrapper = styled.section`
  display: flex;
  flex-direction: column;
  gap: 2rem;
  align-items: center;
  margin: 6rem 0rem;
`;
